import React from 'react';
import More from 'wix-ui-icons-common/More';
import { Divider, PopoverMenu, IconButton, Box, Tooltip, Text, Button, } from 'wix-style-react';
import { translate } from 'react-i18next';
import style from './QuickActionsMenu.scss';
import withTranslation from '../../providers/translation/withTranslation';
var Trigger = function (_a) {
    var noButton = _a.noButton, onClick = _a.onClick, children = _a.children;
    var dataHook = 'quick-actions-menu-button';
    return noButton ? (React.createElement("div", { "data-hook": dataHook, onClick: onClick }, children)) : (React.createElement(IconButton, { dataHook: dataHook, skin: "light", onClick: onClick }, children));
};
var QuickActionsMenu_ = function (_a) {
    var className = _a.className, actions = _a.actions, noButton = _a.noButton, tooltipSize = _a.tooltipSize, onToggle = _a.onToggle, t = _a.t;
    return (React.createElement("div", { className: className },
        React.createElement(PopoverMenu, { textSize: "small", dataHook: "quick-actions-popover-menu", triggerElement: function (_a) {
                var toggle = _a.toggle;
                return (React.createElement(Trigger, { noButton: noButton, onClick: function (e) {
                        e.preventDefault();
                        e.stopPropagation();
                        toggle();
                        onToggle === null || onToggle === void 0 ? void 0 : onToggle();
                    } },
                    React.createElement(Tooltip, { size: tooltipSize, content: t('quick-actions.menu.tooltip') },
                        React.createElement(More, { size: "24", className: style.quickActionsTriggerElementIcon }))));
            } }, actions.map(function (quickAction, i) {
            return (React.createElement(PopoverMenu.MenuItem, { dataHook: "quick-action-menu-item-" + quickAction.id, prefixIcon: quickAction.icon, text: quickAction.name, key: i, skin: quickAction.id === 'delete' ? 'destructive' : undefined, onClick: function () {
                    quickAction.action();
                } }));
        }))));
};
export var QuickActionsMenu = translate()(QuickActionsMenu_);
export var QuickActionsMenuWithTranslation = withTranslation(translate()(QuickActionsMenu_));
export var QuickActionsButtons = function (_a) {
    var className = _a.className, actions = _a.actions;
    var shouldRenderDivider = function (i) {
        return actions.length > 1 && i !== actions.length - 1;
    };
    return (React.createElement(Box, { className: className, justifyContent: "flex-end", overflow: "hidden" }, actions.map(function (quickAction, i) {
        return (React.createElement(Box, { key: "quick-action-button-wrap-" + i, verticalAlign: "middle", className: style.quickActionButtonBox },
            React.createElement(Button, { dataHook: "quick-action-button-" + quickAction.id, className: style.quickActionButton, skin: "light", as: "div", onClick: function () { return quickAction.action(); } },
                React.createElement(Text, { ellipsis: true, className: style.quickActionButtonText },
                    React.createElement("a", null, quickAction.name))),
            shouldRenderDivider(i) && (React.createElement(Box, { height: "24", marginLeft: "1", marginRight: "1" },
                React.createElement(Divider, { direction: "vertical" })))));
    })));
};
//# sourceMappingURL=QuickActionsMenu.js.map